export default __webpack_public_path__ + "static/media/SurveyorText-Black.5ea320c2.woff2";